export const INVALID_PHONE_MESSAGE = "Invalid phone number";

export const sanitizeBangladeshiPhoneNumber = (value: string) =>
  value.replace(/\D/g, "").slice(0, 11);

export const isValidBangladeshiPhoneNumber = (value: string) =>
  /^01\d{9}$/.test(value);
